import React, { FC, ReactNode } from 'react';
import { Cell, Grid }           from "styled-css-grid";
import { Divider, Header }      from 'semantic-ui-react';

import { StyledContainer, StyledContainerProps }                 from '../containers';
import { Align, CorvalUIColor, Position, SemanticUIColor, Size } from '../../types';

export interface ContentUtilContainerProps {
	title?: string | ReactNode,
	titleUtilContent?: ReactNode,
	titleSize?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
	utilContent?: ReactNode,
	introContent?: ReactNode,
	introDivider?: boolean,
	toolingContent?: ReactNode,
	
	titleBarSticky?: boolean,
	titleBarStickyTop?: number,
	titleContainerPadding?: StyledContainerProps['padding']
	
	introContentSticky?: boolean,
	introContentStickyTop?: number,
	introContainerPadding?: StyledContainerProps['padding']
	
	contentContainerPadding?: StyledContainerProps['padding']
}

const defaultProps: ContentUtilContainerProps = {
	title:            'Summary',
	titleUtilContent: null,
	titleSize:        'h3',
	introContent:     null,
	introDivider:     true,
	toolingContent:   null,
	utilContent:      null,
	
	titleBarSticky:        true,
	titleBarStickyTop:     0,
	titleContainerPadding: [ Size.SM, Size.MD ],
	
	introContentSticky:    false,
	introContentStickyTop: 0,
	introContainerPadding: Size.MD,
	
	contentContainerPadding: [ Size.MD, Size.MD, Size.LG, Size.MD ]
};

const ContentUtilContainer: FC<ContentUtilContainerProps> = ( props ) => {
	
	return (
		<>
			{/* Sticky header*/ }
			{ ( props.title || props.titleUtilContent || props.utilContent ) && (
				
				<StyledContainer position={ props.titleBarSticky ? Position.STICKY : Position.RELATIVE } top={ props.titleBarStickyTop } zIndex={ 300 }>
					
					{/* Title & Title Utility Content */ }
					{ ( props.title || props.titleUtilContent ) && (
						
						<StyledContainer bgColor={ SemanticUIColor.PURPLE } padding={ props.titleContainerPadding }>
							<Grid columns={ `1fr auto` }>
								
								{/* Title */ }
								<Cell middle>
									<Header as={ props.titleSize } inverted content={ props.title }/>
								</Cell>
								
								{/* Title Utility Content */ }
								<Cell middle>
									
									{ props.titleUtilContent }
								
								</Cell>
							</Grid>
						</StyledContainer>
					) }
					
					{/* Util content */ }
					{ props.utilContent }
				
				</StyledContainer>
			) }
			
			{/* Intro copy and tooling */ }
			{ ( props.introContent || props.toolingContent ) && (
				
				<StyledContainer padding={ props.introContainerPadding } bgColor={ CorvalUIColor.WHITE } position={ props.introContentSticky ? Position.STICKY : Position.RELATIVE } top={ props.introContentStickyTop } zIndex={ 200 }>
					
					<Grid columns={ `auto 200px` }>
						
						{/* Intro Content */ }
						<Cell middle>
							
							{ props.introContent }
						
						</Cell>
						
						{/* Content Tooling */ }
						<Cell middle>
							
							
							{ props.toolingContent }
						
						</Cell>
					</Grid>
				
				</StyledContainer>
			) }
			
			{/* Content */ }
			{ props.children && (
				
				<StyledContainer padding={ props.contentContainerPadding } position={ Position.RELATIVE } zIndex={ 100 }>
					
					{ props.introDivider && <Divider className={ 'no-margin-top' }/> }
					
					{ props.children }
				
				</StyledContainer>
			) }
		
		</>
	);
};

ContentUtilContainer.defaultProps = defaultProps;

export { ContentUtilContainer }
